import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from '../context/AuthContext';
import { useNotifications } from '../context/NotificationsContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useNotificationsSocket = () => {
  const { user } = useAuth();
  const { addNotification } = useNotifications();
  const socketRef = useRef(null);

  useEffect(() => {
    if (!user) {
      // Disconnect if user logs out
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
      return;
    }

    // Connect to Socket.IO server
    const socket = io(API_URL, {
      path: '/api/socket.io',
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    socketRef.current = socket;

    socket.on('connect', () => {
      console.log('🔔 Notifications Socket connected');
      // Register user for notifications
      socket.emit('register_user', { user_id: user.id });
    });

    socket.on('disconnect', () => {
      console.log('🔔 Notifications Socket disconnected');
    });

    // Listen for notifications
    socket.on('notification', (notification) => {
      console.log('🔔 New notification received:', notification);
      addNotification(notification);
    });

    socket.on('error', (error) => {
      console.error('🔔 Notifications Socket error:', error);
    });

    // Cleanup on unmount
    return () => {
      if (socket) {
        socket.emit('unregister_user', { user_id: user.id });
        socket.disconnect();
      }
    };
  }, [user, addNotification]);

  return socketRef.current;
};
